import React from "react";
import { Form, DrawerProps, Drawer, Descriptions } from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import { formItems } from "./Form/FormComponent";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppSelector } from "../../../../utils/hooks/hooks";
import { renderNA } from "../../../../utils/commonFunctions";

interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a view drawer component for viewing details of a Testimonial record.
 *
 * @param {ViewDrawerProps} props - The props object containing the title name, open state, close function, and additional props.
 * @param {string} props.titleName - The name of the title to be displayed in the view drawer.
 * @param {boolean} props.open - The open state of the view drawer.
 * @param {() => void} props.close - The function to be called when the view drawer is closed.
 * @param {React.HTMLAttributes<HTMLDivElement>} props.rest - Additional props to be spread on the view drawer component.
 * @return {React.ReactElement} The rendered view drawer component.
 */
const ViewDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  const [form] = Form.useForm();
  const details = useAppSelector(state => state.testimonial.details);

  const drawerClose = () => {
    close();
    form.resetFields();
  };

  const formItemsArray = Object.values(formItems);

  const DescriptionItems = () => {
    return (
      <Descriptions column={2} bordered layout="horizontal">
        {formItemsArray.map((item, index) => (
          <Descriptions.Item key={index} label={item.label}>
            {renderNA(details?.[item.name])}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };

  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      <DescriptionItems />
    </Drawer>
  );
};

export default ViewDrawer;
